<template>
  <div class="cat-search">
    <div>
      <div class="main-content" aria-live="polite">
        <a name="main-content"></a>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt");
    const displayParams = inject("displayParams");

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "CatSearch",
  provide: function () {
    return {
      displayParams: this.customizeDisplay()
    };
  },
  props: {
    id: {
      type: [String, Number]
    },
    heading: {
      type: [String]
    },
    errors: {
      type: [Array]
    }
  },
  methods: {
    customizeDisplay: function () {
      const display = this.displayParams;
      display.showLabelOptional = false;
      display.suppressOffscreenOptional = true;
      return display;
    }
  }
});
</script>
